import { useMemo } from 'react';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { ExtensionHandlers } from '@atlaskit/editor-common/extensions/extension-handler';
import type { ExtensionPluginOptions } from '@atlaskit/editor-plugin-extension/extensionPluginType';

import { is1PMacro } from '../extensions-common/macroClassificationUtils.ts';

export type useExtensionRendererViewOptionsProps = {
	isLivePage: boolean;
	contentId: string;
	spaceKey: string;
	getExtensionHandlers?: (options: any) => ExtensionHandlers;
};

export const is1PBodiedExtension = ({
	extensionKey,
	extensionType,
}: {
	extensionKey?: string;
	extensionType?: string;
}): boolean => is1PMacro(extensionKey || '') && extensionType === 'bodiedExtension';

export const is2PBodiedExtension = ({
	extensionKey,
	extensionType,
}: {
	extensionKey?: string;
	extensionType?: string;
}): boolean => !is1PMacro(extensionKey || '') && extensionType === 'bodiedExtension';

export const useExtensionRendererViewOptions = ({
	getExtensionHandlers,
	isLivePage,
	contentId,
	spaceKey,
}: useExtensionRendererViewOptionsProps): ExtensionPluginOptions['__rendererExtensionOptions'] => {
	return useMemo(() => {
		if (isLivePage) {
			return {
				rendererExtensionHandlers: getExtensionHandlers?.({
					contentId,
					spaceKey,
					isInEditorRendererView: true,
				}),
				isAllowedToUseRendererView: (node: ADFEntity) => {
					return is2PBodiedExtension({
						extensionKey: node.attrs?.extensionKey,
						extensionType: node.type,
					});
				},
				showUpdated1PBodiedExtensionUI: (node: ADFEntity) =>
					is1PBodiedExtension({
						extensionKey: node.attrs?.extensionKey,
						extensionType: node.type,
					}),
			};
		}
		return undefined;
	}, [getExtensionHandlers, isLivePage, contentId, spaceKey]);
};
